/**
 * Expected survey-file upload failures (#16364 / SLAPFIVE-FRONTEND-A5D).
 *
 * The signed-URL PUT uses a raw XHR. When the browser fires the XHR `error`
 * event (offline, dropped connection, sleep), there is no HTTP status and no
 * server fault. Callers show a retry message and handle the rejection.
 * If one still reaches Angular's ErrorHandler, it must not be reported.
 */

export const UPLOAD_NETWORK_ERROR_MESSAGE = 'Upload failed due to network error';

export const UPLOAD_RETRY_MESSAGE =
  'Upload failed due to a network error. Check your connection and try again.';

function unwrap(error: unknown): unknown {
  if (error == null || typeof error !== 'object') {
    return error;
  }
  const obj = error as Record<string, unknown>;
  return obj['rejection'] ?? obj['ngOriginalError'] ?? error;
}

function messageOf(error: unknown): string | undefined {
  if (typeof error === 'string') {
    return error;
  }
  if (error == null || typeof error !== 'object') {
    return undefined;
  }
  const message = (error as Record<string, unknown>)['message'];
  return typeof message === 'string' ? message : undefined;
}

export function isUploadNetworkErrorMessage(message: string | null | undefined): boolean {
  return typeof message === 'string' && message.includes(UPLOAD_NETWORK_ERROR_MESSAGE);
}

export function isUploadNetworkError(error: unknown): boolean {
  const candidate = unwrap(error);
  if (isUploadNetworkErrorMessage(messageOf(candidate))) {
    return true;
  }
  return isUploadNetworkErrorMessage(messageOf(error));
}
